export default __webpack_public_path__ + "47c71e30cd54fd0db4dd011002d9559e.svg";